import React from 'react';
import { Col, Row } from 'react-bootstrap';
import BackButton from '../buttons/BackButton';

const ProfileNavigation = props => {
  return (
    <Row style={{ marginBottom: 6, position: 'absolute', width: props.maxWidth, overflowY: 'auto', background: 'none' }} className='department-profile-menu'>
      <Col style={{ display: !props.backLabel ? 'none' : null }}>
        <BackButton onClick={() => props.back()} style={{ float: 'left' }} />
          &nbsp;&nbsp;
        {/* {props.backLabel} */}
      </Col>
      <Col>
        <p
          style={{
            cursor: 'pointer',
            color: 'black',
            textAlign: 'center',
            width: 25,
            height: 25,
            borderRadius: '50%',
            background: 'white',
            float: 'right'
          }}
          onClick={() => props.open(false)}
        >
          <i className='fa fa-close' />
        </p>
      </Col>
    </Row>
  );
};

export default ProfileNavigation;
